import gql from 'graphql-tag';

export const TOKEN_EXPIRATION = gql`
  query TokenExpiration {
    tokenExpiration
  }
`;
